<div class="d-flex pg-t-10">
  <yo-search-panel-mouvements class="mg-r-5"></yo-search-panel-mouvements>
  <router-outlet></router-outlet>
</div>




